import { z } from 'zod';

// Define Zod schema for PositionDetails
export const positionDetailsSchema = z
    .object({
        title: z.string().min(1, 'Position Title is required'),
        role: z.string().min(1, 'Role is required'),
        location: z
            .object({
                id: z.any().optional(),
                name: z.string().min(1, 'Location is required'),
            })
            .nullable()
            .refine((val) => val?.name, 'Location is required'),
        hiringManager: z
            .object({
                id: z.any().optional(),
                fullName: z.string().min(1, 'Hiring Manager is required'),
            })
            .nullable()
            .refine((val) => val?.fullName, 'Hiring Manager is required'),
        employmentType: z.string().min(1, 'Employment Type is required'),
        positionCode: z.string().min(1, 'Position Code is required'),
        minExperience: z.coerce.number().min(1, 'Min Experience is required'),
        maxExperience: z.coerce.number().min(1, 'Max Experience is required'),
        budgetLowerLimit: z.coerce.number().min(1, 'Budget Lower Limit is required'),
        budgetMidLimit: z.coerce.number().min(1, 'Budget Mid Limit is required'),
        budgetUpperLimit: z.coerce.number().min(1, 'Budget Upper Limit is required'),
        mandatorySkills: z.array(z.string()).min(1, 'At least one mandatory skill is required'),
        description: z
            .string()
            .min(1, 'Description is required')
            .refine((val) => val.replace(/<(.|\n)*?>/g, '').trim().length > 0, 'Description cannot be empty'),
    })
    .refine((data) => data.maxExperience >= data.minExperience, {
        message: 'Max Experience must be greater than or equal to Min Experience',
        path: ['maxExperience'],
    });

// Define Zod schema for BasicAttributes
export const basicAttributesSchema = z.object({
    department: z.coerce.string().min(1, 'Department is required'),
    designation: z.coerce.string().min(1, 'Designation is required'),
});

// Define Zod schema for CustomFields
export const createCustomFieldsSchema = (definitions) => {
    if (!definitions) return z.object({});

    const schemaShape = definitions.reduce((acc, field) => {
        if (field.isRequired) {
            acc[field.fieldLabel] = z.string().min(1, `${field.fieldLabel} is required`);
        } else {
            acc[field.fieldLabel] = z.string().optional();
        }
        return acc;
    }, {});
    return z.object(schemaShape);
};
